<template>
      <el-select v-model="companySelected"
                 class="select-transparent-noborder company"
                 @change="changeCompany()">
        <el-option v-if="companies.length != 1" :value="0" label="All Companies" :key="0"/>
        <el-option v-for="company in companies"
                    :value="company.id"
                    :label="company.profile.companyName"
                    :key="company.id"/>
      </el-select>
</template>

<script>
export default {
  name: 'Company-Selector',
  computed: {
    companies () {
      return this.$store.getters.incentifyers.filter(c => !c.archived)
    },
    companySelected: {
      get () { return this.$store.getters.companySelected || (this.companies.length > 1 ? 0 : this.companies[0]) },
      set (companyId) { this.$store.commit('SET_COMPANY_SELECTED', companyId) }
    }
  },
  methods: {
    changeCompany () {
      if (this.$store.getters.companySelected === 0) {
        // We first commit the value
        this.$store.commit('SET_COMPANY_SELECTED', this.companySelected)
        // Then we update the router
        /* this.$router.push('/admin/home/multiview')
      } else {
        if (this.$route.path !== '/admin/home/singleview') {
          this.$router.push({path: '/admin/home/singleview'})
        } */
      }
    }
  }
}
</script>

<style>
.select-transparent-noborder.company {
  width: 160px;
}
</style>